module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-schreibtisch-02.fb72f1d8.jpeg";